<template>
  <div class="body">
    <p>Execute tests:</p>
    <div>
      <button v-on:click="testCsp">Test CSP</button>
      <span v-if="cspTest == 'ok'">CSP ok &#10003;</span>
      <span v-if="cspTest == 'fail'">CSP fail &#10060;</span>
    </div>
    <div>
      <button v-on:click="testServerHeader">Test Server header</button>
      <span v-if="serverHeaderTest == 'ok'">Server header ok &#10003;</span>
      <span v-if="serverHeaderTest == 'fail'">Server header fail &#10060;</span>
    </div>
  </div>
</template>

<script src="./test.ts"></script>
